module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    attrs: {
      "align": "center"
    }
  }, [_c('div', [(_vm.PageNum == '0') ? _c('div', [_c('img', {
    staticStyle: {
      "width": "25%",
      "margin-top": "1.0rem"
    },
    attrs: {
      "src": require("../../../static/portal/card.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.28rem",
      "line-height": "26px"
    }
  }, [_vm._v("您即将成为格林数字卡会员 ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.28rem",
      "line-height": "26px"
    }
  }, [_vm._v("手机号为" + _vm._s(this.UserPhone))]), _vm._v(" "), _c('div', [_c('input', {
    staticStyle: {
      "letter-spacing": "0.1rem",
      "width": "90%",
      "height": "0.8rem",
      "background-color": "#09bb07",
      "border-radius": "5px",
      "border-width": "0",
      "font-size": "16px",
      "color": "#f5f5f5",
      "margin-top": "0.28rem"
    },
    attrs: {
      "type": "button",
      "value": "马上加入"
    },
    on: {
      "click": _vm.GoJoin
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.PageNum == '1') ? _c('div', [_c('img', {
    staticStyle: {
      "width": "10%",
      "margin-top": "1.0rem"
    },
    attrs: {
      "src": require("../../../static/portal/ok.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "color": "#4e4e4e",
      "margin-top": "0.2rem"
    }
  }, [_vm._v("您已成功连接网络")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.28rem",
      "line-height": "26px"
    }
  }, [_vm._v("快来下载APP,更有优惠等你拿 ")])]) : _vm._e(), _vm._v(" "), (_vm.PageNum == '2') ? _c('div', [_c('img', {
    staticStyle: {
      "width": "10%",
      "margin-top": "1.0rem"
    },
    attrs: {
      "src": require("../../../static/portal/ok.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "color": "#4e4e4e",
      "margin-top": "0.2rem"
    }
  }, [_vm._v("您已成功连接网络")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.28rem",
      "line-height": "26px"
    }
  }, [_vm._v("积分更有好礼拿 ")])]) : _vm._e(), _vm._v(" "), (_vm.PageNum == '3') ? _c('div', [_c('img', {
    staticStyle: {
      "width": "10%",
      "margin-top": "1.0rem"
    },
    attrs: {
      "src": require("../../../static/portal/ok.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "color": "#4e4e4e",
      "margin-top": "0.2rem"
    }
  }, [_vm._v("您已成功连接网络")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.28rem",
      "line-height": "26px"
    }
  }, [_vm._v("您已经拥有较多积分啦,可以去兑换礼品")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1.0rem"
    },
    attrs: {
      "align": "center"
    }
  }, [(_vm.PageNum == '0') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.4rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "src": require("../../../static/portal/downloadapp.png")
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.3rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 13px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.85rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoDownload
    }
  }, [_vm._v(" 立即下载")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/free.png")
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.7rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoFree
    }
  }, [_vm._v("  去 看 看")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/168Market.png")
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.6rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.Go168Matker
    }
  }, [_vm._v("去 逛 逛")])])])]) : _vm._e(), _vm._v(" "), (_vm.PageNum == '1') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.4rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "src": require("../../../static/portal/downloadapp.png")
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.3rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 13px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.85rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoDownload
    }
  }, [_vm._v(" 立即下载")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/168Market.png")
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.7rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.Go168Matker
    }
  }, [_vm._v("去 逛 逛")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/free.png")
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.7rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoFree
    }
  }, [_vm._v("  去 看 看")])])])]) : _vm._e(), _vm._v(" "), (_vm.PageNum == '2') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.4rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "src": require("../../../static/portal/downloadapp.png")
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.3rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 13px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.85rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoDownload
    }
  }, [_vm._v(" 立即下载")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/168Market.png")
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.7rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.Go168Matker
    }
  }, [_vm._v("去 逛 逛")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/Kmoney.png")
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.6rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoKMoeny
    }
  }, [_vm._v("  去 看 看")])])])]) : _vm._e(), _vm._v(" "), (_vm.PageNum == '3') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "src": require("../../../static/portal/present.png")
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.3rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.7rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoPresent
    }
  }, [_vm._v(" 去 看 看")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/168Market.png")
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.6rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.Go168Matker
    }
  }, [_vm._v("去 逛 逛")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.0rem",
      "margin-left": "0.4rem",
      "margin-right": "0.4rem",
      "background-color": "#f7f7f7",
      "height": "2.1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "28%",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    },
    attrs: {
      "src": require("../../../static/portal/free.png")
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "0.2rem",
      "margin-right": "0.1rem"
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "0 15px",
      "weight": "2.8rem",
      "line-height": "0.6rem",
      "height": "0.6rem",
      "background-color": "#ef6a31",
      "border-color": "#ef6a31",
      "font-size": "14px",
      "color": "#f5f5f5",
      "margin-top": "0.7rem",
      "display": "inline-block"
    },
    on: {
      "click": _vm.GoFree
    }
  }, [_vm._v("  去 看 看")])])])]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _vm._m(13)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.38rem",
      "color": "#4e4e4e"
    }
  }, [_vm._v("新会员立送"), _c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("￥50")]), _vm._v("元代金券")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("格林APP下载")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v(" 会员首次登录:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v(" 得 "), _c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("¥100")]), _vm._v("住房大礼包")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("¥99.8")]), _vm._v("特惠房抢先订")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("免费住格林")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("会员免费抽奖")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("万元现金等你来赢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("168商城")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("名牌低价")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("2倍差距赔付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("格林APP下载")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v(" 会员首次登录:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v(" 得 "), _c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("¥100")]), _vm._v("住房大礼包")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("¥99.8")]), _vm._v("特惠房抢先订")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("168商城")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("名牌低价")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("2倍差距赔付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("免费住格林")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("会员免费抽奖")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("万元现金等你来赢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("格林APP下载")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v(" 会员首次登录:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v(" 得 "), _c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("¥100")]), _vm._v("住房大礼包")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ff775c"
    }
  }, [_vm._v("¥99.8")]), _vm._v("特惠房抢先订")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("168商城")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("名牌低价")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("2倍差距赔付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("分享赚K币")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("邀好友关注微信")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("无限量K币送不停")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("积分换礼")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("积分就能换好礼")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("海量代金券等你拿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("168商城")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("名牌低价")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("2倍差距赔付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "2.6rem",
      "text-align": "left",
      "float": "left",
      "margin-left": "0.1rem",
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.36rem",
      "line-height": "26px",
      "color": "#4e4e4e",
      "font-weight": "bold"
    }
  }, [_vm._v("免费住格林")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("会员免费抽奖")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "line-height": "22px"
    }
  }, [_vm._v("万元现金等你来赢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "line-height": "28px",
      "font-size": "12px",
      "color": "#999999"
    }
  }, [_vm._v("格林酒店  只需感受")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "28px",
      "font-size": "10px",
      "color": "#cccccc"
    }
  }, [_vm._v("格林豪泰酒店（中国）有限公司版权所有 ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "18px",
      "font-size": "10px",
      "color": "#cccccc"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn"
    }
  }, [_vm._v("沪ICP备14035076号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20c67712!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/Wifiportal.vue
// module id = 1442
// module chunks = 18